<template>
  <div class="container_wang_checkFailed">
    <div class="inner_box">
      <div class="card">
        <p slot="title">
          信息审核
        </p>
      </div>
      <div class="content"><i><img src="../../assets/checkFailed.png"></i>
        <p>审核失败</p>
      </div>
      <div class="warn">
        <p>原因：{{note}}</p>
        <p>点“重新审核”提交新的审核信息</p>
      </div>
      <div style="display: flex;justify-content: center">
        <my-button @confirm="again">重新审核</my-button>
        <my-button @confirm="logout"
                   :style="{backgroundColor:'#fff',border:'1px solid #C7C7C7',color:'#7F7F7F',marginLeft:'20px'}">退出
        </my-button>
      </div>
    </div>
  </div>
</template>
<script>
  import MyButton from '@/components/MyButton'
  import ApiClient from '@/api/ApiClient'
  export default {
    name: "checkFailed",
    components: {
      MyButton,
    },
    data() {
      return {
        note:''
      }
    },
    mounted(){
    this.note = JSON.parse(sessionStorage.getItem('currentUser')).note;
    let detailId = JSON.parse(sessionStorage.getItem('currentUser')).detailId;
    ApiClient.get(`/desktop/profile/checkFail.do`,{
      id:detailId
      }).then(data=>{
    })
    },
    methods: {
      again() {
        this.$router.push({
          name: 'userInfo'
        })
      },
      logout() {
        this.$router.push({
          name: 'login'
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .inner_box {
    width: 866px;
    height: 546px;
    margin: 126px auto;
  }

  .card {
    width: 826px;
    margin: 0 auto;
    font-size: 18px;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid rgba(234, 234, 234, 0.5);
  }

  .content {
    display: flex;
    align-items: center;
    margin-top: 70px;
    margin-bottom: 68px;
    margin-left: 346px;
  }

  .content p {
    font-size: 20px;
    text-align: center;
    color: #525252;
    display: inline-block;
    margin-left: 20px;
  }

  .warn {
    margin-left: 280px;
    margin-bottom: 56px;
    font-size:20px;
  }

  .warn p {
    text-align: left;
    color: #CF4646;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/myProfile/checkFailed.vue